import React, { useContext, useState, useEffect } from 'react';
import { AnimatePresence } from 'motion/react';
import BaseSelect from 'react-select';
import { FirebaseContext } from 'context';
import { ErrorMessage, Button, FixRequiredSelect } from 'components';
import { Container, Title, Card, Label } from '../Shared';

function FormSelect(props) {
  return (
    <FixRequiredSelect
      {...props}
      SelectComponent={BaseSelect}
      options={props.options}
    />
  );
}

const emailTypes = [
  {
    label: 'Reminder For Low Contributors',
    value: 'reminder-email-low-contribution'
  },
  {
    label: 'Reminder For Already Contributing',
    value: 'reminder-email-already-contributing'
  },
  {
    label: 'New Question Released',
    value: 'new-question-released'
  }
];

function Emails({ customDropdownMenuStyles }) {
  const { firebase } = useContext(FirebaseContext);
  const [selectedEmailType, setSelectedEmailType] = useState(null);
  const [formIncomplete, setFormIncomplete] = useState(true);
  const [sendingEmail, setSendingEmail] = useState(false);
  const [users, setUsers] = useState([]);
  const [selectedUser, setSelectedUser] = useState(null);
  const [error, setError] = useState({
    code: '',
    message: ''
  });

  const populateUserList = (result) => {
    if (!result.empty) {
      setUsers((currrentValue) => [
        ...currrentValue,
        ...result.docs.map((doc) => {
          const { name, email, uid, sessionsUserHasAccessTo } = doc.data();
          return {
            label: name,
            value: {
              name,
              email,
              uid,
              sessionsUserHasAccessTo
            }
          };
        })
      ]);
    }
  };

  useEffect(() => {
    if (firebase) {
      firebase.misc.getAllUsers().then(populateUserList);
    }
    return () => setUsers([]);
  }, [firebase]);

  useEffect(() => {
    if (selectedEmailType && selectedUser) {
      setFormIncomplete(false);
    } else {
      setFormIncomplete(true);
    }
    if (error) {
      setError({
        code: '',
        message: ''
      });
    }
  }, [selectedUser, selectedEmailType]);

  const handleSendEmail = async () => {
    try {
      setSendingEmail(true);
      if (selectedEmailType.value.includes('reminder-email')) {
        await firebase.emails.sendReminder({
          users: [selectedUser.value],
          templateAlias: selectedEmailType.value,
          // Sender identity resolves server-side (config/tenant); admins may
          // still override From/ReplyTo per send if an instance needs it.
          emailData: {
            TemplateModel: {
              site_url: window.location.origin
            }
          }
        });
      } else {
        await firebase.emails.sendNewQuestionReleased({
          users: [selectedUser.value],
          templateAlias: selectedEmailType.value,
          emailData: {
            TemplateModel: {
              site_url: window.location.origin
            }
          }
        });
      }
    } catch (_error) {
      console.error('Error sending email:', _error.message);
      setError({
        code: _error.code,
        message: _error.message
      });
    } finally {
      setSelectedUser(null);
      setSelectedEmailType(null);
      setSendingEmail(false);
    }
  };

  return users ? (
    <Container>
      <Title>Emails</Title>
      <Card>
        <div>
          <Label>Select Users</Label>
          <FormSelect
            // isMulti
            value={selectedUser}
            onChange={setSelectedUser}
            placeholder="Select"
            styles={customDropdownMenuStyles()}
            options={users}
          />
        </div>
        <div>
          <Label>Email Type</Label>
          <FormSelect
            value={selectedEmailType}
            onChange={setSelectedEmailType}
            placeholder="Select"
            styles={customDropdownMenuStyles()}
            options={emailTypes}
          />
        </div>
        <ErrorMessage errorMessage={error.message} />
        <AnimatePresence>
          <Button
            type="button"
            loading={sendingEmail}
            style={{
              margin: '0.75rem auto 0'
            }}
            disabled={formIncomplete}
            onClick={handleSendEmail}
            changeColorWhenDisabled={false}>
            Send Email
          </Button>
        </AnimatePresence>
      </Card>
    </Container>
  ) : (
    ''
  );
}

export default Emails;
